<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'首页推荐管理管理'},{name:'融资产品推荐列表',goback:true},{name:'编辑融资产品推荐'}]" :title="'编辑融资产品推荐'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-suffix="："
        >
          <el-form-item
            label="产品名称"
            prop="name"
            class="formitem"
          >
            {{ruleForm.name}}
          </el-form-item>

          <el-form-item label="贷款类型">
            <el-input
              disabled
              v-model="ruleForm.type"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行名称">
            <el-input
              disabled
              v-model="ruleForm.bankName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="序号"
            prop="sort"
          >
            <el-input v-model="ruleForm.sort"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary" size="small"
              @click="submitForm('ruleForm')"
            >确认</el-button>
            <el-button @click="resetForm('ruleForm')" size="small">取消</el-button>
          </el-form-item>
        </el-form>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
           ruleForm: {
                id: void 0,
                sort: void 0,
                sourceId:void 0,
                type:void 0,
            },
            rules: {
                 sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                sourceId:{ required: true, message: '请选择产品名称', trigger: 'change' }
            
            },
            newsDataSelect:[],
            edit:true
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		// /backstage/sysDict/parentId
		this.getSelect()
    const {id} = this.$route.params
		if(id){
		    this.id=id;
			  this.ruleForm.id=id;
			  this.getDetail();
		}
		
	},
   
    methods:{
      async getSelect() {
            const {data,msg,code} = await this.$axiosc.get('backstage/act/select', {})
            if (code == 200) {
                    this.newsDataSelect = data || [];
                } else {
                    this.$alert(msg)
                }

        },
		getDetail(){
			this.$axiosc.get('/backstage/hotProduct/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.ruleForm = Object.assign(this.ruleForm,r.data)
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submitForm(formName) {
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                  const {id,sort} = that.ruleForm
                   const param = {
                     id,
                     sort
                   }
                    that.$axioscBody.put('/backstage/hotProduct/edit', param).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm={
                sort: null,
                sourceId:null,
                type:null,
            }
            this.$refs[formName].resetFields();
            this.$router.back(-1);
        },
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 50px;
        border-top:1px solid rgba(112, 112, 112, 0.1);
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>